var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "up_svg__up"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.5978L14.1454 11.6848C14.5697 12.1051 15.2576 12.1051 15.6818 11.6848C16.1061 11.2646 16.1061 10.5833 15.6818 10.1631L8.76818 3.31517C8.34393 2.89495 7.65607 2.89495 7.23182 3.31517L0.318191 10.1631C-0.106064 10.5833 -0.106064 11.2646 0.318191 11.6848C0.742445 12.1051 1.4303 12.1051 1.85455 11.6848L8 5.5978Z",
    fill: "currentColor"
  })));
};
export default SvgUp;